import { LocaleValuesFragment } from 'src/generated/operations.ts';
import { UnitValue } from 'src/common/types/UnitValue.ts';

export type AttributesListItem = [
    string,
    LocaleValuesFragment | null | undefined,
];
export type AttributesListItemMulti = [
    string,
    LocaleValuesFragment | Array<LocaleValuesFragment | UnitValue | undefined | null> | null | undefined,
];
export type AttributesList = Array<AttributesListItem>;

export function createAttributesItem(
    label: string = '',
    value: LocaleValuesFragment | null | undefined = null,
): AttributesList {
    if (!value) {
        return [] as AttributesList;
    }
    return [[label, value]];
}
